import Component from '../abstracts/Component';
const {Crawler, middleware} = require('./../../../../node_modules/es6-crawler-detect/src')
import CarouselComponent from "./CarouselComponent";
import WishlistComponent from "./WishlistComponent";

/**
 Recommendation Engine Component
 */
export default class RecommendationEngineComponent extends Component {

  static get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_CONTAINER: '.recommendation-engine-container',
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: '.recommendation-engine-products-container',
      RECOMMENDATION_TITLE: '.recommendation__title-wrapper',
      wishBtn: '.js-wishlist-cta'
    };
  }

  static get CONSTANTS() {
    return {
      RECOMMENDATION_ENGINE_URL:  "/ajax/recommendation",
      GET: "GET",
    };
  }

  render() {
    let recommendationComponent = document.querySelector(RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    if(recommendationComponent != null){
      this.setup(recommendationComponent);
    }
  }

  constructor(compEl) {
    super(compEl);
    this.carouselComponent = new CarouselComponent();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");

    for(let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }

    if(timeoutTime != null) {
      xhttp.timeout = timeoutTime;
    }

    xhttp.open(RecommendationEngineComponent.CONSTANTS.GET, contextPath + RecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi ,"%20"), true);

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      }else{
        if (this.readyState === 4 && (this.status === 500 || this.status === 404)) {
          callBackOnFailure();
        }
      }
    };

    xhttp.ontimeout = function () {
      callBackOnFailure();
    };

    xhttp.onerror = function () {
      callBackOnFailure();
    };

    xhttp.send();
  }

  renderData(data) {
    let recommendationProductsComponent = document.querySelector(RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    let recommendationTitle = document.querySelector(RecommendationEngineComponent.SELECTORS.RECOMMENDATION_TITLE);

    if(recommendationProductsComponent != null){
      recommendationProductsComponent.innerHTML = data.responseText;
      let productsContainer = recommendationProductsComponent.querySelector(RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
      // loads slick then carousel el
      this.carouselComponent.importLibrary(productsContainer, true);
      // render wishlist to link async btns
      this.wishlistComponent = new WishlistComponent(recommendationProductsComponent);
      this.wishlistComponent.render(recommendationProductsComponent.querySelectorAll(RecommendationEngineComponent.SELECTORS.wishBtn));

      if((data.responseText).trim() != ""){
        $(recommendationTitle).css('display', 'flex');
      }
      this.$emit(this.$customEvents.LOAD_COMPONENT.simplebar);
      this.$emit(this.$customEvents.LOAD_COMPONENT.completethelook);
    }
  }

  tryAgain() {
    let recommendationComponent = this.$component;
    this.callServer(this.getSimilarOpts(recommendationComponent), this.renderData.bind(this), this.hideComponent.bind(this), null);
  }

  hideComponent() {
    let recommendationComponent = this.$component;

    if(recommendationComponent != null){
      recommendationComponent.closest('.w-complete-look').innerHTML = "";
    }
  }

  setup (recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;
    if(!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(this.getMarketingOpts(recommendationComponent), this.renderData.bind(this), template === "t-product" ? this.tryAgain.bind(this) : this.hideComponent.bind(this), timeout);
    } else {
      this.hideComponent();
    }
  }

}
